import { isEnableNewService } from '@/utils/experiment';

export const getVueAppBaseApi = () => {
  return isEnableNewService() ? process.env.VUE_APP_BASE_API : process.env.VUE_APP_BASE_API?.replace('.cartsee.com', '.cartx.cloud');
};

export const getVueAppUploadApi = () => {
  return isEnableNewService() ? process.env.VUE_APP_UPLOAD_API : process.env.VUE_APP_UPLOAD_API?.replace('.cartsee.com', '.cartx.cloud');
};
